import {
  sendGoogleEvent,
  sendAmplitudeEvent,
  sendRequest,
} from '@html/_common/utils';

import AOCarousel from '@atomic/organisms/_common/carousel/carousel';

export default function initiateWhereStay(eventCategory, tourId) {
  let isModalAccommodationsStarted = false;
  const disabledAccordionsSelector = '.js-ao-tour-where-stay .js-ao-common-accordion__content--disabled';
  const $disabledAccordions = $(disabledAccordionsSelector).closest('.js-ao-common-accordion');
  const accommodationsModalButton = '.js-ao-tour-where-stay-accommodations__modal-button';
  const accommodationsModal = '#accommodations_modal';
  const accommodationsModalClose = '.js-ao-tour-where-stay-accommodations__modal-close';

  $disabledAccordions.forEach((accordion) => {
    const $accordion = $(accordion);
    $accordion.addClass('ao-common-accordion--disabled js-ao-common-accordion--disabled');
    $accordion.find('.js-ao-common-accordion__bottom').remove();
    $accordion.find('.ao-common-accordion__arrow').removeClass('ao-common-accordion__arrow');
  });

  $('.js-ao-tour-where-stay .js-ao-common-accordion--disabled').click(() => {
    sendGoogleEvent(eventCategory, 'Where You Will Stay', 'Accommodation Type Disabled - Click Attempt');
  });

  const whereStayCarousel = new AOCarousel('.js-ao-tour-where-stay__carousel');
  const accommodationCarousel = new AOCarousel('.js-ao-tour-where-stay-accommodations__carousel');
  const eventAction = 'Where You Will Stay';

  $('body').on('click', '.js-ao-tour-where-stay__image', () => {
    sendGoogleEvent(
      eventCategory,
      eventAction,
      'Click Thumbnail',
    );
  });

  whereStayCarousel.onScrollAnalytics(() => {
    sendGoogleEvent(
      eventCategory,
      eventAction,
      'Scroll',
    );
  });

  whereStayCarousel.onLeftClickAnalytics(() => {
    sendGoogleEvent(
      eventCategory,
      eventAction,
      'Previous',
    );
  });

  whereStayCarousel.onRightClickAnalytics(() => {
    sendGoogleEvent(
      eventCategory,
      eventAction,
      'Next',
    );
  });

  whereStayCarousel.initiate();
  accommodationCarousel.initiate();

  $(`${accommodationsModalButton}, .js-ao-tour-where-stay-accommodations__carousel-item`).on('click', () => {
    sendAmplitudeEvent({ ampEventName: 'tdp_accommodation_modal_opened' });

    if (isModalAccommodationsStarted) {
      $(accommodationsModal).removeClass('hid');
      $('body').addClass('layer');
      $('html').addClass('layer');
      return;
    }
    sendRequest('/api/popup/tour-accommodations', { tourId }, (response) => {
      if (!response.success) sendGoogleEvent('Error', 'Tour Accommodations', 'No response');

      $('.js-ao-tour-where-stay-accommodations__container').append(response.template);
      $(accommodationsModal).toggleClass('hid');
      $('html').toggleClass('layer');
      $('body').toggleClass('layer');

      $('.js-ao-tour-where-stay-accommodations__modal-carousel').each((_, element) => {
        const carousel = new AOCarousel(element);
        carousel.initiate();
      });
      $(accommodationsModalClose).on('click', () => {
        $(accommodationsModal).addClass('hid');
        $('body').removeClass('layer');
        $('html').removeClass('layer');
        sendAmplitudeEvent({ ampEventName: 'tdp_accommodation_modal_closed' });
      });
      isModalAccommodationsStarted = true;
      return response.success;
    }, { type: 'GET' });
  });
}
